import { render, staticRenderFns } from "./ModalPoints.vue?vue&type=template&id=3345efd8"
import script from "./ModalPoints.vue?vue&type=script&lang=js"
export * from "./ModalPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports